// GoTaps — Team Data

export const TEAM_COLORS = ["#64748b","#18181b","#059669","#d97706","#dc2626","#0891b2","#db2777","#7c3aed","#ea580c","#0d9488"];
export const TEAM_ICONS  = ["🏆","⚡","📣","🎯","🚀","💡","🔥","🌟","👑","💎","🦅","🎪","🛡","⚙️","🌊"];
